import { useState } from "@wordpress/element";
import { IImageryFilter } from "@/types/imagery-type";
import { useDispatch } from "@wordpress/data";
import { WEATHER_STORE } from "@/store/store";
import { WeatherDispatch } from "@/store/type";
import { useTranslation } from "react-i18next";

import "./style.scss";

type LayerMapProps = {
	setShowStation: () => void;
	setShowImagery: () => void;
	showStation: boolean;
	showImagery: boolean;
};

export const LayerMap = ({
	setShowStation,
	setShowImagery,
	showStation,
	showImagery,
}: LayerMapProps) => {
	const { t } = useTranslation();

	const { setObservationFilter } = useDispatch(
		WEATHER_STORE,
	) as WeatherDispatch;
	const [layerType, setLayerType] = useState<
		{
			name: string;
			isChecked: boolean;
			id: IImageryFilter;
		}[]
	>([
		{
			name: "dust",
			isChecked: true,
			id: IImageryFilter.dust,
		},
		{
			name: "ir",
			isChecked: false,
			id: IImageryFilter.sat,
		},
		{
			name: "radar",
			isChecked: false,
			id: IImageryFilter.rad_ir,
		},
	]);

	const handleSelectLayer = (name: string) => {
		const findLayer = layerType.find((item) => item.name === name);

		if (!findLayer) {
			return;
		}
		setObservationFilter(findLayer.id);
		setLayerType((prev) =>
			prev.map((item) => ({
				...item,
				isChecked: item.name === name,
			})),
		);
	};

	return (
		<div className="layer-map">
			<p className="title">{t("layers")}</p>

			<ul>
				{layerType.map((item) => (
					<li key={item.name}>
						<label htmlFor={item.name}>{t(item.name)}</label>
						<input
							type="radio"
							id={item.name}
							name={item.name}
							value={item.name}
							checked={item.isChecked}
							onClick={() => handleSelectLayer(item.name)}
						/>
					</li>
				))}
			</ul>

			<div className="div-check" onClick={() => setShowStation()}>
				<label htmlFor="station">{t("stations")}</label>
				<div className="slider">
					<span className={showStation ? "right" : "left"}></span>
				</div>
			</div>

			<div className="div-check" onClick={() => setShowImagery()}>
				<label htmlFor="station">{t("imagery")}</label>
				<div className="slider">
					<span className={showImagery ? "right" : "left"}></span>
				</div>
			</div>
		</div>
	);
};

export default LayerMap;
